import React from "react";
import {useTranslation} from "react-i18next";
import { useLocation } from 'react-router-dom';


const MetaDataTable = ({data, ind}) => {

    const {t} = useTranslation();
   const { pathname } = useLocation();
   const finance = pathname === '/finance';



    return (
        <>
            {ind === 0 ? (
                finance ? (
                <table className="finance-table w-full table-auto text shadow-xl">
                    <tbody className="bg-white divide-y-2 divide-gray-200">
                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">1</td>
                        <td className="font-bold w-80">
                        {t('metadata.table1.1')}
                        </td>
                        <td className="font-bold w-fit">{data?.name}</td>
                    </tr>

                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">2</td>
                        <td className="font-bold w-80">
                        {t('metadata.table1.2')}
                        </td>
                        <td className="p-1">{data?.purpose}</td>
                    </tr>

                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">3</td>
                        <td className="font-bold w-80">
                        {t('metadata.table1.3')}
                        </td>
                        <td className="p-1">{data?.description}</td>
                    </tr>

                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">4</td>
                        <td className="font-bold w-80">
                        {t('metadata.table1.4')}
                        </td>
                        <td className="p-1">{data?.scope}</td>
                    </tr>

                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">5</td>
                        <td className="font-bold w-80">
                        {t('metadata.table1.5')}
                        </td>
                        <td className="p-1">{data?.methodology}</td>
                    </tr>

                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">6</td>
                        <td className="font-bold w-80">
                        {t('metadata.table1.6')}
                        </td>
                        <td className="p-1">{data?.legal_basis}</td>
                    </tr>

                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">7</td>
                        <td className="font-bold w-80">
                        {t('metadata.table1.7')}
                        </td>
                        <td className="p-1">{data?.source}</td>
                    </tr>

                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">8</td>
                        <td className="font-bold w-80">
                        {t('metadata.table1.8')}
                        </td>
                        <td className="p-1">{data?.main_metrics}</td>
                    </tr>

                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">9</td>
                        <td className="font-bold w-80">
                        {t('metadata.table1.9')}
                        </td>
                        <td className="p-1">{data?.measurement}</td>
                    </tr>

                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">10</td>
                        <td className="font-bold w-80">
                        {t('metadata.table1.10')}
                        </td>
                        <td className="p-1">{data?.frequency}</td>
                    </tr>
                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">11</td>
                        <td className="font-bold w-80">
                        {t('metadata.table1.11')}
                        </td>
                        <td className="p-1">{data?.date_of_survey}</td>
                    </tr>
                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">12</td>
                        <td className="font-bold w-80">
                        {t('metadata.table1.12')}
                        </td>
                        <td className="p-1">{data?.start_date}</td>
                    </tr>
                    </tbody>
                </table>
                ) : (
                <table className="finance-table w-full table-auto text shadow-xl">
                    <tbody className="bg-white divide-y-2 divide-gray-200">
                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">1</td>
                        <td className="font-bold w-80">
                        {t('metadata.table.1')}
                        </td>
                        <td className="font-bold w-fit">{data?.name}</td>
                    </tr>

                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">2</td>
                        <td className="font-bold w-80">
                        {t('metadata.table.2')}
                        </td>
                        <td className="p-1">{data?.description}</td>
                    </tr>

                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">3</td>
                        <td className="font-bold w-80">
                        {t('metadata.table.3')}
                        </td>
                        <td className="p-1">{data?.methodology}</td>
                    </tr>

                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">4</td>
                        <td className="font-bold w-80">
                        {t('metadata.table.4')}
                        </td>
                        <td className="p-1">{data?.measurement}</td>
                    </tr>

                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">5</td>
                        <td className="font-bold w-80">
                        {t('metadata.table.5')}
                        </td>
                        <td className="p-1">{data?.frequency}</td>
                    </tr>

                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">6</td>
                        <td className="font-bold w-80">
                        {t('metadata.table.6')}
                        </td>
                        <td className="p-1">{data?.date_of_survey}</td>
                    </tr>

                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">7</td>
                        <td className="font-bold w-80">
                        {t('metadata.table.7')}
                        </td>
                        <td className="p-1">{data?.source}</td>
                    </tr>

                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">8</td>
                        <td className="font-bold w-80">
                        {t('metadata.table.8')}
                        </td>
                        <td className="p-1">{data?.start_date}</td>
                    </tr>

                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">9</td>
                        <td className="font-bold w-80">
                        {t('metadata.table.9')}
                        </td>
                        <td className="p-1">{data?.made_by}</td>
                    </tr>

                    <tr className="h-14">
                        <td className="font-bold w-16 text-center">10</td>
                        <td className="font-bold w-80">
                        {t('metadata.table.10')}
                        </td>
                        <td className="p-1">{data?.last_modified_date}</td>
                    </tr>
                    </tbody>
                </table>
                )
            ) : (
                <div className="m-auto text-center p-10">
                <p className="text-lg">{t('metadata.notFound')}</p>
                </div>
            )}
        </>
    )
}

export default MetaDataTable;